<div class="task-grid">
    <div class="task-updater">
        <ubs-task-updater [updater]="updater" [parameters]="updateParameters"></ubs-task-updater>
        <!-- <nb-accordion>
            <nb-accordion-item expanded>
                <nb-accordion-item-header>{{updater?.title}}</nb-accordion-item-header>
                <nb-accordion-item-body>
                    <ubs-task-updater [updater]="updater" [parameters]="updateParameters"></ubs-task-updater>
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion> -->
    </div>
    <div class="task-selector">
        <ubs-task-selector [selector]="selector" (selectorParameters)="setUpdaterParameters($event)"></ubs-task-selector>
        <!-- <nb-accordion>
            <nb-accordion-item expanded>
                <nb-accordion-item-header>{{selector?.title}}</nb-accordion-item-header>
                <nb-accordion-item-body>
                    <ubs-task-selector [selector]="selector" (selectorParameters)="setUpdaterParameters($event)"></ubs-task-selector>
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion> -->
    </div>
    
    <div class="task-effect">
        <ubs-task-effect [effect]="effect"></ubs-task-effect>
        <!-- <nb-accordion>
            <nb-accordion-item expanded>
                <nb-accordion-item-header>{{effect?.title}}</nb-accordion-item-header>
                <nb-accordion-item-body>
                    <ubs-task-effect [effect]="effect"></ubs-task-effect>
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion> -->
        
    </div>
</div>



